import { MemberRemarksListComponent } from '../../../../shared/member-remarks-list/member-remarks-list.component';
import { CurrencySettingsDialogComponent } from './affiliate-groups/dialogs/currency-settings/currency-settings.component';
import { SettlementSettingsComponent } from './affiliate-groups/dialogs/settlement-settings/settlement-settings.component';
import { AllAffiliateMemberDialogComponent } from './../../../../shared/all-affiliate-member-dialog/all-affiliate-member-dialog.component';
import { PdfDialogComponent } from './../../../../shared/pdf-dialog/pdf-dialog.component';
import { AffiliateAdjustmentDialogComponent } from './affiliate-adjustments/dialogs/affiliate-adjustments-edit.component';
import { AffiliateAdjustmentsComponent } from './affiliate-adjustments/affiliate-adjustments.component';
import { AffiliateCampaignsComponent } from './affiliate-campaigns/affiliate-campaigns.component';
import { AdjustGroupDialogComponent } from './all-affiliates/dialogs/adjust-group/adjust-group.component';
import { AffiliateApprovalComponent } from './affiliate-approval/affiliate-approval.component';
import { AffiliateApprovalEditDialogComponent } from './affiliate-approval/dialog/affiliate-approval-edit.component';
import { AffiliateApprovalSettingsDialogComponent } from './affiliate-approval/dialog/affiliate-approval-settings/affiliate-approval-settings.component';
import { AffiliateDepositDetailsComponent } from './affiliate-deposits/dialog/deposit-details.component';
import { AffiliateDepositsComponent } from './affiliate-deposits/affiliate-deposits.component';
import { AffiliateInformationComponent } from './all-affiliates/dialogs/affiliate-information/affiliate-information.component';
import { AffiliateMemberComponent } from './all-affiliates/dialogs/affiliate-member/affiliate-member.component';
import { AffiliateRemarkComponent } from './all-affiliates/dialogs/affiliate-remark/affiliate-remark.component';
import { AffiliateWithdrawalsComponent } from './affiliate-withdrawals/affiliate-withdrawals.component';
import { AffiliateWithdrawEditDialogComponent } from './affiliate-withdrawals/dialog/affiliate-withdraw-edit.component';
import { AgentComponent } from './agent/agent.component';
import { AgentEditDialogComponent } from './agent/dialogs/agent-edit.component';
import { AgentTreeViewComponent } from './agent-tree-view/agent-tree-view.component';
import { AllAffiliatesComponent } from './all-affiliates/all-affiliates.component';
import { AllAffiliatesEditDialogComponent } from './all-affiliates/dialogs/all-affiliates-edit/all-affiliates-edit.component';
import { AllAffiliatesPasswordDialogComponent } from './all-affiliates/dialogs/all-affiliates-password/all-affiliates-password.component';
import { AllEventsComponent } from './all-events/all-events.component';
import { AllEventsEditDialogComponent } from './all-events/dialogs/all-events-edit/all-events-edit.component';
import { AllLeadsAssignDialogComponent } from './all-leads/dialogs/all-leads-assign/all-leads-assign.component';
import { AllLeadsImportDialogComponent } from './all-leads/dialogs/all-leads-import/all-leads-import.component';
import { AffiliateSettingsDialogComponent } from './all-leads/dialogs/affiliate-settings/affiliate-settings.component';
import { AffiliateSettingsAddDialogComponent } from './all-leads/dialogs/affiliate-settings-add/affiliate-settings-add.component';
import { AllLeadsComponent } from './all-leads/all-leads.component';
import { AllPredictionsComponent } from './all-predictions/all-predictions.component';
import { AllTicketsComponent } from './all-tickets/all-tickets.component';
import { BankReceiptBrowserDialogComponent } from '../settings/bank-receipts/dialogs/bank-receipt-browser/bank-receipt-browser.component';
import { BetLimitDialogComponent } from './groups/dialogs/bet-limit/bet-limit.component';
import { CallLogDialogComponent } from './my-leads/dialogs/call-logs/call-log.component';
import { CCIDLookupDialogComponent } from './ccid-lookup/ccid-lookup.component';
import { CommissionReleasesComponent } from './commission-releases/commission-releases.component';
import { DepositComponent } from './deposits/deposit.component';
import { DepositDetailsComponent } from './deposits/dialogs/deposit-details/deposit-details.component';
import { DepositDetailsNewComponent } from './deposits/dialogs/deposit-details-new/deposit-details-new.component';
import { DepositApproveComponent } from './deposits/dialogs/deposit-approve/deposit-approve.component';
import { DepositLimitDialogComponent } from './groups/dialogs/deposit-limit/deposit-limit.component';
import { GameProviderBlacklistComponent } from './promotion-codes/dialogs/game-provider-blacklist/game-provider-blacklist.component';
import { GameProviderNewBlacklistComponent } from './promotion-codes/dialogs/game-provider-new-blacklist/game-provider-new-blacklist.component';
import { GameProviderEditDialogComponent } from '../games/game-providers/dialogs/game-provider-edit.component';
import { GenerateCommissionComponent } from './commission-releases/dialogs/generate-commission/generate-commission.component';
import { GroupComponent } from './groups/group.component';
import { GroupEditDialogComponent } from './groups/dialogs/group-edit.component';
import { LuckyDrawDialogComponent } from './lucky-draw-settings/dialogs/lucky-draw-edit.component';
import { LuckyDrawSettingsComponent } from './lucky-draw-settings/lucky-draw-settings.component';
import { DailyCheckInComponent } from './daily-check-in/daily-check-in.component';
import { MemberBankAccountEditDialogComponent } from './members/dialogs/member-bank-account/member-bank-account-edit/member-bank-account-edit.component';
import { MemberBlacklistDialogComponent } from './members/dialogs/member-blacklist/member-blacklist.component';
import { MemberComponent } from './members/member.component';
import { MemberDeductDialogComponent } from './members/dialogs/member-deduct/member-deduct.component';
import { MemberGameAccountDialogComponent } from './members/dialogs/member-information/member-game-account/member-game-account.component';
import { MemberGameLogDialogComponent } from './members/dialogs/member-game-log/member-game-log.component';
import { MemberGameLogDetailsDialogComponent } from './members/dialogs/member-game-log-details/member-game-log-details.component';
import { MemberInformationDialogComponent } from './members/dialogs/member-information/member-information.component';
import { MemberOnlineComponent } from './member-online/member-online.component';
import { PwaMembersComponent } from './pwa-members/pwa-members.component';
import { BetLimitComponent } from './bet-limit/bet-limit.component';
import { BetLimitSetupComponent } from './bet-limit/bet-limit-setup/bet-limit-setup.component';
import { AddPlayersDialogComponent } from './bet-limit/dialogs/add-players/add-players.component';
import { MemberPasswordDialogComponent } from './members/dialogs/member-password/member-password.component';
import { MemberProfileDialogComponent } from './members/dialogs/member-profile/member-profile.component';
import { MemberPromotionComponent } from './member-promotions/member-promotion.component';
import { MemberPromotionEditDialogComponent } from './member-promotions/dialogs/member-promotion-edit.component';
import { ClaimRewardDialogComponent } from './member-promotions/dialogs/claim-reward-dialog/claim-reward-dialog.component';
import { TransferOutConfirmationDialogComponent } from './member-promotions/dialogs/transfer-out-confirmation-dialog/transfer-out-confirmation-dialog.component';
import { MemberRemarksHistoryComponent } from './members/dialogs/member-remarks-history/member-remarks-history.component';
import { MemberRewardsDialogComponent } from './members/dialogs/member-rewards/member-rewards.component';
import { MemberTopupDialogComponent } from './members/dialogs/member-topup/member-topup.component';
import { MemberTraceComponent } from './member-trace/member-trace.component';
import { MemberVerificationComponent } from './member-verification/member-verification.component';
import { MemberVerificationDetailsComponent } from './member-verification/dialogs/member-verification-details/member-verification-details.component';
import { MerchantBanksDialogComponent } from '../settings/merchant-banks/dialogs/merchant-banks/merchant-banks.component';
import { MyLeadsComponent } from './my-leads/my-leads.component';
import { NgModule } from '@angular/core';
import { PromotionApplicationComponent } from './promotion-application/dialogs/promotion-application.component';
import { PromotionApplicationWrapperComponent } from './promotion-application/promotion-application-wrapper.component';
import { PromotionCategoryComponent } from './promotion-content-category/promotion-category.component';
import { PromotionCategoryM7Component } from './promotion-content-category-m7/promotion-category-m7.component';
import { PromotionCategoryEditDialogComponent } from './promotion-content-category/dialogs/promotion-category-edit.component';
import { PromotionCategoryM7EditDialogComponent } from './promotion-content-category-m7/dialogs/promotion-category-m7-edit.component';
import { PromotionCodeComponent } from './promotion-codes/promotion-code.component';
import { ArchivedPromotionCodeComponent } from './archived-promotion-codes/archived-promotion-code.component';
import { PromotionCodeDetailsDialogComponent } from './promotion-codes/dialogs/promotion-code-details/promotion-code-details';
import { PromotionContentComponent } from './promotion-contents/promotion-content.component';
import { PromotionContentEditDialogComponent } from './promotion-contents/dialogs/promotion-content-edit.component';
import { PromotionCurrencyComponent } from './promotion-currency/promotion-currency.component';
import { PromotionCurrencyDetailsComponent } from './promotion-currency/dialogs/promotion-currency-details.component';
import { PromotionMemberListComponent } from './promotion-member-list/promotion-member-list.component';
import { PromotionMemberDetailsComponent } from './promotion-member-list/dialogs/promotion-member-list-details.component';
import { PromotionMessageDetailsComponent } from './promotion-codes/dialogs/promotion-message-details/promotion-message-details.component';
import { PromotionMessagesComponent } from './promotion-codes/dialogs/promotion-messages/promotion-messages.component';
import { PromotionStatisticComponent } from './promotion-statistic/promotion-statistic.component';
import { RebateSettingsDialogComponent } from './groups/dialogs/rebate-settings/rebate-settings.component';
import { RecoveryPromotionComponent } from './recovery-promotion/recovery-promotion.component';
import { RecoveryPromotionEditDialogComponent } from './recovery-promotion/dialogs/recovery-promotion-edit.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { ReferralSettingsComponent } from './referral-settings/referral-settings.component';
import { ReferralSettingsEditDialogComponent } from './referral-settings/dialogs/referral-settings-edit.component';
import { ReleaseCommissionsDialogComponent } from './commission-releases/dialogs/release-commissions/release-commissions.component';
import { RemarksHistoryComponent } from '../settings/merchant-banks/dialogs/remarks-history/remarks-history.component';
import { ReuploadDocumentDialogComponent } from './members/dialogs/member-bank-account/reupload-document/reupload-document.component';
import { RewardDetailsDialogComponent } from './rewards/dialogs/reward-details/reward-details.component';
import { RewardsComponent } from './rewards/rewards.component';
import { RewardsSettingsDialogComponent } from './lucky-draw-settings/dialogs/rewards-settings-edit/rewards-settings-edit.component';
import { Routes, RouterModule } from '@angular/router';
import { StatusRemarksComponent } from './../settings/merchant-banks/dialogs/status-remarks/status-remarks.component';
import { TelemarketerRewardsComponent } from './telemarketer-rewards/telemarketer-rewards.component';
import { TelemarketerRewardDetailsDialogComponent } from './telemarketer-rewards/dialogs/telemarketer-reward-details/telemarketer-reward-details.component';
import { TelemarketerSettingsComponent } from './telemarketer-settings/telemarketer-settings.component';
import { TelemarketerSettingsEditDialogComponent } from './telemarketer-settings/dialogs/telemarketer-settings-edit/telemarketer-settings-edit.component';
import { TelemarketerSettingsLogComponent } from './telemarketer-settings/dialogs/telemarketer-settings-log/telemarketer-settings-log.component';
import { TransactionComponent } from './transactions/transaction.component';
import { TransactionWalletDialogComponent } from './transactions/dialogs/transaction-wallet/transaction-wallet.component';
import { TransferComponent } from './transfers/transfer.component';
import { TransferEditDialogComponent } from './transfers/dialogs/transfer-edit.component';
import { UpdateResultDialogComponent } from './all-events/dialogs/update-result/update-result.component';
import { WithdrawalComponent } from './withdrawals/withdrawal.component';
import { WithdrawalEditDialogComponent } from './withdrawals/dialogs/withdrawal-single/withdrawal-edit.component';
import { WithdrawalEditDialogV2Component } from './withdrawals/dialogs/withdrawal-single-v2/withdrawal-edit-v2.component';
import { WithdrawalLimitDialogComponent } from './groups/dialogs/withdrawal-limit/withdrawal-limit.component';
import { AffiliateTransfersComponent } from './affiliate-transfers/affiliate-transfers.component';
import { AffiliateGroupsEditDialogComponent } from './affiliate-groups/dialogs/affiliate-groups-edit/affiliate-groups-edit.component';
import { AffiliateGroupsComponent } from './affiliate-groups/affiliate-groups.component';
import { TierRateSettingsDialogComponent } from './affiliate-groups/dialogs/tier-rate-settings/tier-rate-settings.component';
import { CommissionSettingsDialogComponent } from './affiliate-groups/dialogs/commission-settings/commission-settings.component';
import { AllLeadsCallLogComponent } from './all-leads/dialogs/all-leads-call-log/all-leads-call-log.component';
import { LiveChatComponent } from './live-chat/live-chat.component';
import { SampleMessageComponent } from './sample-messages/sample-message.component';
import { SampleMessageEditDialogComponent } from './sample-messages/dialogs/sample-message-edit.component';
import { SubAffiliateComponent } from './all-affiliates/dialogs/sub-affiliate/sub-affiliate.component';
import { RemarkDialogComponent } from './all-leads/dialogs/remark/remark.component';
import { ShowRemarkComponent } from './all-leads/dialogs/show-remark/show-remark.component';
import { EventTeamsDialogComponent } from './all-events/dialogs/event-teams/event-teams.component';
import { EventTeamsEditDialogComponent } from './all-events/dialogs/event-teams-edit/event-teams-edit.component';
import { MemberLabelComponent } from './members/dialogs/member-label/member-label.component';
import { MemberLabelEditComponent } from './members/dialogs/member-label/member-label-edit/member-label-edit.component';
import { ImportRewardsDialogComponent } from './rewards/dialogs/import-rewards/import-rewards.component';
import { LeadRemarksComponent } from './lead-remarks/lead-remarks.component';
import { ShowEvidenceComponent } from './my-leads/dialogs/show-evidence/show-evidence.component';
import { RequestJustificationDialogComponent } from './all-leads/dialogs/request-justification/request-justification.component';
import { RequestReceiptDialogComponent } from '@shared/request-receipt-dialog/request-receipt-dialog.component';
import { UrlTestFireDialogComponent } from './all-affiliates/dialogs/url-test-fire/url-test-fire.component';
import { ShowRemarkHistoryComponent } from './deposits/dialogs/show-remark-history/show-remark-history.component';
import { ViewReceiptComponent } from './deposits/dialogs/view-receipt/view-receipt.component';
import { StatusCheckDialogComponent } from './transfers/dialogs/status-check/status-check.component';
import { CreateMemberDialogComponent } from './my-leads/dialogs/create-member/create-member.component';
import { UploadReceiptComponent } from './deposits/dialogs/upload-receipt/upload-receipt.component';
import { MemberPromotionHistoryComponent } from './members/dialogs/member-promotion-history/member-promotion-history.component';
import { TestFirePostbackLogsComponent } from './all-affiliates/dialogs/test-fire-postback-logs/test-fire-postback-logs.component';
import { MemberCryptoAccountEditDialogComponent } from './members/dialogs/member-bank-account/member-crypto-account-edit/member-crypto-account-edit.component';
import { WithdrawalWrapperComponent } from './withdrawals/withdrawal-wrapper/withdrawal-wrapper.component';
import { MemberPromotionEligibleDialogComponent } from './members/dialogs/member-promotion-eligible/member-promotion-eligible.component';
import { PromotionCodeMemberEligibleDialogComponent } from './promotion-codes/dialogs/promotion-code-member-eligible/promotion-code-member-eligible.component';
import { PromotionContentMemberEligibleDialogComponent } from './promotion-contents/dialogs/promotion-content-member-eligible/promotion-content-member-eligible.component';
import { RewardMemberEligibleDialogComponent } from './rewards/dialogs/reward-member-eligible/reward-member-eligible.component';
import { DepositWrapperComponent } from './deposits/deposit-wrapper/deposit-wrapper.component';
import { UndoLeadsDialogComponent } from './all-leads/dialogs/undo-lead/undo-lead.component';
import { ReassignLeadsDialogComponent } from './all-leads/dialogs/reassign-lead/reassign-lead.component';
import { ExtendLeadsDialogComponent } from './all-leads/dialogs/extend-lead/extend-lead.component';
import { AffiliateGroupsDialogBulkAddComponent } from './affiliate-groups/dialogs/affiliate-groups-edit/dialogs/affiliate-groups-dialog-bulk-add.component';
import { AffiliateGroupsPromotionBulkAddComponent } from './affiliate-groups/dialogs/affiliate-groups-edit/promotions/affiliate-groups-promotion-bulk-add.component';
import { AffiliateGroupsInboxBulkAddComponent } from './affiliate-groups/dialogs/affiliate-groups-edit/inboxes/affiliate-groups-inbox-bulk-add.component';
import { AffiliateGroupsMemberGroupBulkAddComponent } from './affiliate-groups/dialogs/affiliate-groups-edit/member-groups/affiliate-groups-member-group-bulk-add.component';
import { PromotionAffiliateComponent } from './promotion-codes/dialogs/promotion-affiliate/promotion-affiliate.component';
import { AccountManagementComponent } from './account-management/account-management.component';
import { AccountManagementLogDialogComponent } from './account-management/dialogs/account-managment-log/account-management-log-dialog.component';
import { AccountManagementKpiSettingsDialogComponent } from './account-management/dialogs/kpi-settings/kpi-settings-dialog.component';
import { AssignLeadDialogComponent } from './account-management/dialogs/assign-lead/assign-lead-dialog.component';
import { AccountManagementRemarkComponent } from './account-management/dialogs/account-management-remark/account-management-remark.component';
import { ViewAttachmentComponent } from './account-management/dialogs/view-attachment/view-attachment.component';
import { MemberVerificationWrapperComponent } from './member-verification/member-verification-wrapper/member-verification-wrapper.component';
import { ShowDocumentComponent } from './member-bank-account-verification/dialogs/show-document/show-document.component';
import { MemberBankAccountVerificationDetailsComponent } from './member-bank-account-verification/dialogs/member-bank-account-verification-details/member-bank-account-verification-details.component';
import { MemberBankAccountVerificationRemarkComponent } from './member-bank-account-verification/dialogs/member-bank-account-verification-remark/member-bank-account-verification-remark.component';
import { LeadHistoryComponent } from './all-leads/dialogs/lead-history/lead-history.component';
import { RaffleEventsComponent } from './raffle-events/raffle-events.component';
import { RaffleEventDetailComponent } from './raffle-events/raffle-event-details/raffle-event-detail.component';
import { RaffleEventsEditDialogComponent } from './raffle-events/raffle-event-details/dialogs/raffle-event-detail-edit/raffle-event-edit.component';
import { RaffleEventNameDialogComponent } from './raffle-events/raffle-event-details/dialogs/raffle-event-name-dialog/raffle-event-name-dialog.component';
import { VerificationSettingsComponent } from './verification-settings/verification-settings.component';
import { VerificationSettingsEditDialogComponent } from './verification-settings/dialogs/verification-settings-edit/verification-settings-edit.component';
import { VerificationSettingsCurrencyDialogComponent } from './verification-settings/dialogs/verification-settings-currency/verification-settings-currency.component';
import { VerificationSettingsCurrencyContentComponent } from './verification-settings/dialogs/verification-settings-currency-content/verification-settings-currency-content.component';
import { VerificationSettingsBankComponent } from './verification-settings/dialogs/verification-settings-bank/verification-settings-bank.component';
import { VerificationSettingsBankDetailComponent } from './verification-settings/dialogs/verification-settings-bank/dialogs/verification-settings-bank-detail.component';
import { VIPNameDialogComponent } from '../vip/settings/dialogs/vip-name-dialog/vip-name-dialog.component';
import { VIPContentNameDialogComponent } from '../vip/vip-content-settings/dialogs/vip-name-dialog/vip-content-name-dialog.component';
import { DepositLogComponent } from './deposits/dialogs/deposit-log/deposit-log.component';
import { DepositLogWrapperComponent } from './deposits/dialogs/deposit-log-wrapper/deposit-log-wrapper.component';
import { ImportVIPsDialogComponent } from '../vip/all-vips/dialogs/import-vips/import-vips.component';
import { WithdrawalLogComponent } from './withdrawals/dialogs/withdrawal-log/withdrawal-log.component';
import { WithdrawalLogWrapperComponent } from './withdrawals/dialogs/withdrawal-log-wrapper/withdrawal-log-wrapper.component';
import { ViewWithdrawalReceiptComponent } from './withdrawals/dialogs/view-withdrawal-receipt/view-withdrawal-receipt.component';
import { MemberLabelRemarkDialogComponent } from './members/dialogs/member-label-remark/member-label-remark.component';
import { MemberLabelSettingsComponent } from './members/dialogs/member-label-settings/member-label-settings.component';
import { MemberLabelSettingsEditComponent } from './members/dialogs/member-label-settings/member-label-settings-edit/member-label-settings-edit.component';
import { MemberLabelListComponent } from './members/dialogs/member-label-list/member-label-list.component';
import { AssignTargetDialogComponent } from './all-leads/dialogs/assign-target/assign-target.component';
import { RoleAccessGuard } from '@core/guards/role-access.guard';
import { UnSaveChangesGuard } from '@core/guards/unsavechanges.guard';
import { AppPermissionKeys } from '@core/models/app-permissions.model';
import { PromotionCodeComponent2 } from './promotion-codes-2/promotion-code-2.component';
import { BasicSettingComponent } from './promotion-codes-2/child-components/basic-setting/basic-setting.component';
import { EligibilitySettingComponent } from './promotion-codes-2/child-components/eligibility-setting/eligibility-setting.component';
import { PromotionTypeComponent } from './promotion-codes-2/child-components/promotion-type/promotion-type.component';
import { MemberSettingComponent } from './promotion-codes-2/child-components/member-setting/member-setting.component';
import { MessageSettingComponent } from './promotion-codes-2/child-components/message-setting/message-setting.component';
import { KycSettingComponent } from './promotion-codes-2/child-components/kyc-setting/kyc-setting.component';
import { PromotionCurrencySettingComponent } from './promotion-codes-2/child-components/promotion-currency-setting/promotion-currency-setting.component';
import { PromotionNameSettingComponent } from './promotion-codes-2/child-components/promotion-name-setting/promotion-name-setting.component';
import { BlacklistTemplateComponent } from './promotion-codes/dialogs/blacklist-template/blacklist-template.component';
import { BlacklistTemplateSettingComponent } from './promotion-codes/dialogs/blacklist-template-setting/blacklist-template-setting.component';

const routes: Routes = [
  {
    path: "members",
    children: [
      {
        path: "",
        pathMatch: "full",
        component: MemberComponent,
        data: { permissions: AppPermissionKeys.view_member_list },
      },
    ],
  },
  {
    path: "member-groups",
    component: GroupComponent,
    data: { permissions: AppPermissionKeys.view_member_group_list },
  },
  {
    path: "member-verification",
    component: MemberVerificationWrapperComponent,
    data: { permissions: AppPermissionKeys.view_member_verification_list },
  },

  // AIO-6758 -- Hide per request
  // {
  //   path: 'vip-verification',
  //   component: VipVerificationComponent
  // },
  {
    path: "member-online",
    component: MemberOnlineComponent,
    data: { permissions: AppPermissionKeys.view_member_online_list },
  },
  {
    // AIO-81798 — Members 1.7
    path: "pwa-members",
    component: PwaMembersComponent,
    data: { permissions: AppPermissionKeys.view_pwa_member_list },
  },
  {
    // AIO-81599 — Members 1.8
    path: "bet-limit",
    component: BetLimitComponent,
    data: { permissions: AppPermissionKeys.view_sport_bet_limit_group_list },
  },
  {
    path: "bet-limit/setup",
    component: BetLimitSetupComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_sport_bet_limit_group_list },
  },
  {
    path: "member-trace",
    component: MemberTraceComponent,
    data: { permissions: AppPermissionKeys.view_member_trace_list },
  },
  {
    path: "referrals",
    component: ReferralsComponent,
    data: { permissions: AppPermissionKeys.view_referrals_list },
  },
  {
    path: "deposits",
    component: DepositWrapperComponent,
    data: { permissions: [AppPermissionKeys.view_banking_deposits, AppPermissionKeys.view_crypto_deposits] },
  },
  {
    path: "withdrawals",
    component: WithdrawalWrapperComponent,
    data: { permissions: [AppPermissionKeys.view_banking_withdrawals, AppPermissionKeys.view_crypto_withdrawals] },
  },
  {
    path: "transfers",
    component: TransferComponent,
    data: { permissions: AppPermissionKeys.view_transfers_list },
  },
  {
    path: "transactions",
    children: [
      {
        path: "",
        pathMatch: "full",
        component: TransactionComponent,
        data: { permissions: AppPermissionKeys.view_transactions_list },
      },
    ],
  },
  {
    path: "member-promotions",
    component: MemberPromotionComponent,
    data: { permissions: AppPermissionKeys.view_member_promotions_list },
  },
  {
    path: "promotion-codes",
    component: PromotionCodeComponent,
    data: { permissions: AppPermissionKeys.view_promotion_codes_list },
  },
  {
    path: "archived-promotion-codes",
    component: ArchivedPromotionCodeComponent,
    data: { permissions: AppPermissionKeys.view_archived_promotion_codes_list },
  },
  {
    path: 'promotion-setup',
    component: PromotionCodeComponent2,
    data: { permissions: AppPermissionKeys.view_promotion_codes_list },
  },
  {
    path: "promotion-contents",
    component: PromotionContentComponent,
    data: { permissions: AppPermissionKeys.view_promotion_contents_list },
  },
  {
    path: "promotion-statistics",
    component: PromotionStatisticComponent,
    data: { permissions: AppPermissionKeys.view_promotion_statistics },
  },
  {
    path: "recovery-promotions",
    component: RecoveryPromotionComponent,
    data: { permissions: AppPermissionKeys.view_recovery_promotion_list },
  },
  {
    path: "promotion-category",
    component: PromotionCategoryComponent,
    data: { permissions: AppPermissionKeys.view_promotion_content_category_list },
  },
  {
    path: "promotion-content-category",
    component: PromotionCategoryM7Component,
    data: { permissions: AppPermissionKeys.view_promotion_content_category_list },
  },
  {
    path: "referral-settings",
    component: ReferralSettingsComponent,
    data: { permissions: AppPermissionKeys.view_referral_settings_list },
  },
  {
    path: "lucky-draw-settings",
    component: LuckyDrawSettingsComponent,
    data: { permissions: AppPermissionKeys.view_lucky_draw_settings_list },
  },
  {
    // AIO-80387. Path must match the `link` seeded on the daily_checkin ApplicationSection
    // ('general/daily-check-in') — that seeded value is what the API-driven sidebar renders.
    path: "daily-check-in",
    component: DailyCheckInComponent,
    // Grid edits live only in memory until Save, so leaving mid-edit must prompt — same guard
    // partner-page uses.
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_daily_checkin_list },
  },
  {
    path: "promotion-applications",
    component: PromotionApplicationWrapperComponent,
    data: { permissions: AppPermissionKeys.view_promotion_applications_list },
  },
  {
    path: "rewards",
    component: RewardsComponent,
    data: { permissions: AppPermissionKeys.view_rewards_list },
  },
  {
    path: "agents",
    component: AgentComponent,
    data: { permissions: AppPermissionKeys.view_agents_list },
  },
  {
    path: "agent-tree-view",
    component: AgentTreeViewComponent,
    data: { permissions: AppPermissionKeys.view_agents_list },
  },
  {
    path: "prediction-tickets",
    component: AllTicketsComponent,
    data: { permissions: AppPermissionKeys.view_tickets_list },
  },
  {
    path: "all-predictions",
    component: AllPredictionsComponent,
    data: { permissions: AppPermissionKeys.view_predictions_list },
  },
  {
    path: "prediction-events",
    component: AllEventsComponent,
    data: { permissions: AppPermissionKeys.view_events_list },
  },
  {
    path: "all-leads",
    component: AllLeadsComponent,
    data: { permissions: AppPermissionKeys.view_leads_list },
  },
  {
    path: "account-management",
    component: AccountManagementComponent,
    data: {
      permissions: [
        AppPermissionKeys.view_own_normal_account_manager_account_management_list,
        AppPermissionKeys.view_own_vip_account_manager_account_management_list,
      ]
    },
  },
  {
    path: "commission-releases",
    component: CommissionReleasesComponent,
    data: { permissions: AppPermissionKeys.view_commission_releases_list },
  },
  {
    path: "all-affiliates",
    component: AllAffiliatesComponent,
    data: { permissions: AppPermissionKeys.view_all_affiliates_list },
  },
  {
    path: "affiliate-withdrawals",
    component: AffiliateWithdrawalsComponent,
    data: { permissions: AppPermissionKeys.view_affiliate_withdrawals_list },
  },
  {
    path: "affiliate-deposits",
    component: AffiliateDepositsComponent,
    data: { permissions: AppPermissionKeys.view_affiliate_deposits_list },
  },
  {
    path: "affiliate-approval",
    component: AffiliateApprovalComponent,
    data: { permissions: AppPermissionKeys.view_affiliates_approvals_list },
  },
  {
    path: "affiliate-transfers",
    component: AffiliateTransfersComponent,
    data: { permissions: AppPermissionKeys.view_affiliate_transfer_list },
  },
  {
    path: "affiliate-adjustments",
    component: AffiliateAdjustmentsComponent,
    data: { permissions: AppPermissionKeys.view_affiliate_adjustments_list },
  },
  {
    path: "affiliate-campaigns",
    component: AffiliateCampaignsComponent,
    data: { permissions: AppPermissionKeys.view_affiliate_campaigns_list },
  },
  {
    path: "affiliate-groups",
    component: AffiliateGroupsComponent,
    data: { permissions: AppPermissionKeys.view_affiliate_groups_list },
  },
  {
    path: "live-chat",
    component: LiveChatComponent,
    data: { permissions: AppPermissionKeys.view_live_chat_script_list },
  },
  {
    path: "sample-messages",
    component: SampleMessageComponent,
  },
  {
    path: "my-leads",
    component: MyLeadsComponent,
    data: { permissions: AppPermissionKeys.view_my_leads_list },
  },
  {
    path: "lead-remarks",
    component: LeadRemarksComponent,
    data: { permissions: AppPermissionKeys.view_lead_remarks },
  },
  {
    path: "telemarketer-rewards",
    component: TelemarketerRewardsComponent,
    data: { permissions: [AppPermissionKeys.view_own_telemarketer_rewards_list, AppPermissionKeys.view_own_normal_account_manager_rewards_list, AppPermissionKeys.view_own_vip_account_manager_rewards_list] },
  },
  {
    path: "telemarketer-settings",
    component: TelemarketerSettingsComponent,
    data: { permissions: AppPermissionKeys.view_telemarketer_setting_list },
  },
  {
    path: "raffle-events",
    component: RaffleEventsComponent,
    data: { permissions: AppPermissionKeys.view_raffle_events_list },
  },
  {
    path: "verification-settings",
    component: VerificationSettingsComponent,
    data: { permissions: AppPermissionKeys.view_verification_settings_list },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    AddPlayersDialogComponent,
    AffiliateAdjustmentDialogComponent,
    AdjustGroupDialogComponent,
    AffiliateApprovalEditDialogComponent,
    AffiliateApprovalSettingsDialogComponent,
    AffiliateDepositDetailsComponent,
    AffiliateInformationComponent,
    AffiliateMemberComponent,
    AffiliateRemarkComponent,
    AffiliateWithdrawEditDialogComponent,
    AgentEditDialogComponent,
    AllAffiliatesEditDialogComponent,
    AllAffiliatesPasswordDialogComponent,
    AllEventsEditDialogComponent,
    AllLeadsAssignDialogComponent,
    AllLeadsImportDialogComponent,
    AffiliateSettingsDialogComponent,
    AffiliateSettingsAddDialogComponent,
    BankReceiptBrowserDialogComponent,
    BlacklistTemplateComponent,
    BlacklistTemplateSettingComponent,
    BetLimitDialogComponent,
    CallLogDialogComponent,
    CCIDLookupDialogComponent,
    DepositDetailsComponent,
    DepositDetailsNewComponent,
    DepositApproveComponent,
    DepositLimitDialogComponent,
    GameProviderBlacklistComponent,
    GameProviderNewBlacklistComponent,
    GameProviderEditDialogComponent,
    GenerateCommissionComponent,
    GroupEditDialogComponent,
    LuckyDrawDialogComponent,
    LiveChatComponent,
    SampleMessageComponent,
    // SampleMessageDetailsComponent,
    MemberBankAccountEditDialogComponent,
    MemberCryptoAccountEditDialogComponent,
    MemberBlacklistDialogComponent,
    MemberDeductDialogComponent,
    MemberGameAccountDialogComponent,
    MemberGameLogDialogComponent,
    MemberGameLogDetailsDialogComponent,
    MemberInformationDialogComponent,
    MemberPasswordDialogComponent,
    MemberProfileDialogComponent,
    MemberPromotionEditDialogComponent,
    ClaimRewardDialogComponent,
    TransferOutConfirmationDialogComponent,
    MemberRemarksHistoryComponent,
    MemberRewardsDialogComponent,
    MemberRewardsDialogComponent,
    MemberTopupDialogComponent,
    MemberVerificationDetailsComponent,
    MerchantBanksDialogComponent,
    PromotionApplicationComponent,
    PromotionCategoryEditDialogComponent,
    PromotionCategoryM7EditDialogComponent,
    PromotionCodeDetailsDialogComponent,
    PromotionContentEditDialogComponent,
    PromotionCurrencyComponent,
    PromotionCurrencyDetailsComponent,
    PromotionMemberListComponent,
    PromotionMemberDetailsComponent,
    PromotionMessageDetailsComponent,
    PromotionMessagesComponent,
    RebateSettingsDialogComponent,
    RecoveryPromotionEditDialogComponent,
    ReferralSettingsEditDialogComponent,
    ReleaseCommissionsDialogComponent,
    RemarkDialogComponent,
    AccountManagementLogDialogComponent,
    AccountManagementKpiSettingsDialogComponent,
    AssignLeadDialogComponent,
    AccountManagementRemarkComponent,
    ViewAttachmentComponent,
    RequestJustificationDialogComponent,
    RemarksHistoryComponent,
    ReuploadDocumentDialogComponent,
    RewardDetailsDialogComponent,
    RewardsComponent,
    RewardsSettingsDialogComponent,
    StatusRemarksComponent,
    ShowRemarkComponent,
    ShowRemarkHistoryComponent,
    TransactionWalletDialogComponent,
    TransferEditDialogComponent,
    UpdateResultDialogComponent,
    WithdrawalEditDialogComponent,
    WithdrawalEditDialogV2Component,
    WithdrawalLimitDialogComponent,
    PdfDialogComponent,
    AllAffiliateMemberDialogComponent,
    AffiliateGroupsEditDialogComponent,
    CommissionSettingsDialogComponent,
    TierRateSettingsDialogComponent,
    CurrencySettingsDialogComponent,
    AllLeadsCallLogComponent,
    SampleMessageEditDialogComponent,
    RequestReceiptDialogComponent,
    SettlementSettingsComponent,
    SubAffiliateComponent,
    MemberRemarksListComponent,
    EventTeamsDialogComponent,
    EventTeamsEditDialogComponent,
    MemberLabelComponent,
    MemberLabelEditComponent,
    ImportRewardsDialogComponent,
    ShowEvidenceComponent,
    CreateMemberDialogComponent,
    UrlTestFireDialogComponent,
    ShowEvidenceComponent,
    ViewReceiptComponent,
    UploadReceiptComponent,
    StatusCheckDialogComponent,
    MemberPromotionHistoryComponent,
    TestFirePostbackLogsComponent,
    MemberPromotionEligibleDialogComponent,
    PromotionCodeMemberEligibleDialogComponent,
    PromotionContentMemberEligibleDialogComponent,
    RewardMemberEligibleDialogComponent,
    TelemarketerRewardsComponent,
    TelemarketerRewardDetailsDialogComponent,
    UndoLeadsDialogComponent,
    ReassignLeadsDialogComponent,
    ExtendLeadsDialogComponent,
    TelemarketerSettingsComponent,
    TelemarketerSettingsEditDialogComponent,
    TelemarketerSettingsLogComponent,
    AffiliateGroupsDialogBulkAddComponent,
    AffiliateGroupsPromotionBulkAddComponent,
    AffiliateGroupsInboxBulkAddComponent,
    AffiliateGroupsMemberGroupBulkAddComponent,
    PromotionAffiliateComponent,
    ShowDocumentComponent,
    MemberBankAccountVerificationDetailsComponent,
    MemberBankAccountVerificationRemarkComponent,
    LeadHistoryComponent,
    RaffleEventsComponent,
    RaffleEventDetailComponent,
    RaffleEventsEditDialogComponent,
    RaffleEventNameDialogComponent,
    VerificationSettingsComponent,
    VerificationSettingsEditDialogComponent,
    VerificationSettingsCurrencyDialogComponent,
    VerificationSettingsCurrencyContentComponent,
    VerificationSettingsBankComponent,
    VerificationSettingsBankDetailComponent,
    VIPNameDialogComponent,
    VIPContentNameDialogComponent,
    DepositLogComponent,
    DepositLogWrapperComponent,
    ImportVIPsDialogComponent,
    WithdrawalLogComponent,
    WithdrawalLogWrapperComponent,
    ViewWithdrawalReceiptComponent,
    MemberLabelRemarkDialogComponent,
    MemberLabelSettingsComponent,
    MemberLabelSettingsEditComponent,
    MemberLabelListComponent,
    AssignTargetDialogComponent,
    BasicSettingComponent,
    EligibilitySettingComponent,
    PromotionTypeComponent,
    MemberSettingComponent,
    MessageSettingComponent,
    PromotionCurrencySettingComponent,
    KycSettingComponent,
    PromotionNameSettingComponent,
  ]
})
export class GeneralRoutingModule { }
